
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const Language = {
  en: 'en',
  sr: 'sr',
  si: 'si'
} as const

export type Language = (typeof Language)[keyof typeof Language]


export const UserRole = {
  ADMIN: 'ADMIN',
  USER: 'USER',
  ACCOUNTANT: 'ACCOUNTANT'
} as const

export type UserRole = (typeof UserRole)[keyof typeof UserRole]


export const Currency = {
  EUR: 'EUR',
  USD: 'USD',
  RSD: 'RSD',
  GBP: 'GBP'
} as const

export type Currency = (typeof Currency)[keyof typeof Currency]


export const InvoiceStatus = {
  PAID: 'PAID',
  UNPAID: 'UNPAID',
  SENT: 'SENT',
  OVERDUE: 'OVERDUE'
} as const

export type InvoiceStatus = (typeof InvoiceStatus)[keyof typeof InvoiceStatus]


export const ExpenseCategory = {
  OFFICE_SUPPLIES: 'OFFICE_SUPPLIES',
  TRAVEL: 'TRAVEL',
  UTILITIES: 'UTILITIES',
  SOFTWARE: 'SOFTWARE',
  MARKETING: 'MARKETING',
  EQUIPMENT: 'EQUIPMENT',
  MEALS: 'MEALS',
  TRANSPORTATION: 'TRANSPORTATION',
  OTHER: 'OTHER'
} as const

export type ExpenseCategory = (typeof ExpenseCategory)[keyof typeof ExpenseCategory]


export const PaymentMethod = {
  CASH: 'CASH',
  CREDIT_CARD: 'CREDIT_CARD',
  DEBIT_CARD: 'DEBIT_CARD',
  BANK_TRANSFER: 'BANK_TRANSFER',
  PAYPAL: 'PAYPAL',
  OTHER: 'OTHER'
} as const

export type PaymentMethod = (typeof PaymentMethod)[keyof typeof PaymentMethod]


export const Plan = {
  FREE: 'FREE',
  STARTER: 'STARTER',
  PRO: 'PRO'
} as const

export type Plan = (typeof Plan)[keyof typeof Plan]


export const TicketStatus = {
  OPEN: 'OPEN',
  IN_PROGRESS: 'IN_PROGRESS',
  RESOLVED: 'RESOLVED',
  CLOSED: 'CLOSED'
} as const

export type TicketStatus = (typeof TicketStatus)[keyof typeof TicketStatus]


export const TicketPriority = {
  LOW: 'LOW',
  NORMAL: 'NORMAL',
  HIGH: 'HIGH'
} as const

export type TicketPriority = (typeof TicketPriority)[keyof typeof TicketPriority]
